/* eslint-disable eqeqeq */
import React from 'react';
import { openUrl, showAndroidToast } from './insta_custom_views/utils_android/AndroidMethods';
import { UsersApi } from '../../components_android/api/UsersApi';
import { rememberTelegramBound } from '../../motion/Loading';

const TELEGRAM_BOT_URL = "https://t.me/mobile_zarabotok_bot"

// Уведомление вверху главного экрана для всех, у кого не привязан Telegram.
// Тап открывает бота @mobile_zarabotok_bot и диалог: пользователь пишет боту
// /start, копирует код из ответа, вставляет его в диалог и жмет «Отправить» —
// код уходит в /api/addTelegramToEmployer. Привязка определяется по
// непустому полю telegram_chat_id у юзера.
class TelegramBindBanner extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            isBound : false,
            isShowDialog : false,
            code : '',
            isSending : false,
            errorText : ''
        }
    }
    isTelegramBound = () => {
        if (this.state.isBound){
            return true
        }
        var info = this.props.info
        return info != undefined && info != null && info.telegram_chat_id != undefined && info.telegram_chat_id != null && info.telegram_chat_id != ""
    }
    openBot = () => {
        openUrl(TELEGRAM_BOT_URL)
        // диалог остается ждать: вернувшись из Telegram, пользователь вставит код
        this.setState({isShowDialog : true, errorText : ''})
    }
    onCodeChanged = (e) => {
        this.setState({code : e.target.value, errorText : ''})
    }
    sendCode = () => {
        var code = this.state.code.trim()
        if (code == ""){
            this.setState({errorText : "Вставьте код из сообщения бота"})
            return
        }
        this.setState({isSending : true, errorText : ''})
        UsersApi.addTelegramToEmployer(code, () => {
            this.setState({isBound : true, isShowDialog : false, isSending : false})
            rememberTelegramBound(true)
            showAndroidToast("Телеграм привязан")
        }, (responseData) => {
            this.setState({
                isSending : false,
                errorText : responseData && responseData.status ? responseData.status : "Не удалось привязать. Проверьте код и попробуйте еще раз."
            })
        })
    }
    closeDialog = () => {
        this.setState({isShowDialog : false, isSending : false, errorText : ''})
    }
    render(){
        if (this.isTelegramBound()){
            return null
        }
        return (
            <div>
                <div className="telegram_bind_banner" onClick={this.openBot}>
                    Привязать телеграм для важных оповещений
                </div>
                {this.state.isShowDialog &&
                <div className="cap_captcha_dialog_bg">
                    <div className="cap_captcha_dialog">
                        <p className="cap_captcha_dialog_title">Привязка Telegram</p>
                        <p className="telegram_bind_dialog_text">1. Напишите боту <strong>@mobile_zarabotok_bot</strong> команду <strong>/start</strong></p>
                        <p className="telegram_bind_dialog_text">2. Скопируйте код из ответа бота и вставьте его сюда:</p>
                        <input
                            className="telegram_code_input"
                            type="text"
                            placeholder="Код из бота"
                            value={this.state.code}
                            onChange={this.onCodeChanged}
                            disabled={this.state.isSending}
                        />
                        {this.state.errorText != '' &&
                            <p className="telegram_bind_error">{this.state.errorText}</p>
                        }
                        <button className="task_btn telegram_bind_btn" onClick={this.sendCode} disabled={this.state.isSending}>
                            {this.state.isSending ? "Отправка…" : "Отправить"}
                        </button>
                        <div className="telegram_bind_links">
                            <span className="telegram_bind_link" onClick={() => openUrl(TELEGRAM_BOT_URL)}>Открыть бота</span>
                            <span className="telegram_bind_link" onClick={this.closeDialog}>Позже</span>
                        </div>
                    </div>
                </div>
                }
            </div>
        );
    }
}
export default TelegramBindBanner;
